import { useState, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import useCompanyFilters from "~/hooks/useCompanyFilters";
import { AdvancedSearchContext } from "~/providers/AdvancedSearchProvider";
import AdvancedSearchFilterBar from "~/features/AdvancedSearch/AdvancedSearchFilterBar";
import FilterToggle from "../ListToggle/FilterToggle";
import ItemList2 from "../ListLayout/ItemList2";
import { FilterOption } from "~/types/filters.types";

const Companies = () => {
    const { t } = useTranslation();
    const { companies, search, setSearch, isLoading } = useCompanyFilters();
    const { companyFilters, setCompanyFilters, setTriggerSearch } =
        useContext(AdvancedSearchContext);

    // Temp list for changes before update event
    const [tempList, setTempList] = useState<FilterOption[]>(companyFilters);
    const enableUpdate =
        tempList.length !== companyFilters.length ||
        !companyFilters.every(f => tempList.find(tf => tf.id === f.id));

    const resetItems = () => {
        setSearch("");
        // setTempList(companyFilters);
    };

    const handleUpdate = () => {
        // Update context data when update button is clicked
        if (tempList.length > 0) {
            setCompanyFilters(tempList);
        } else {
            setCompanyFilters([]);
        }

        setTriggerSearch(true);
    };

    useEffect(() => {
        if (companyFilters.length !== tempList.length) setTempList(companyFilters);
    }, [companyFilters]);

    return (
        <FilterToggle label={t("company")} count={tempList.length} panelWidth={"w-[114px]"}>
            {({ open }) => (
                <>
                    <AdvancedSearchFilterBar
                        placeholder={`${t("searchCategory1", { category: t("company").toLowerCase() })}`}
                        search={search}
                        setSearch={setSearch}
                        bgColor="bg-stone-lighter"
                    />
                    <ItemList2
                        label={t("companies")}
                        items={companies}
                        listItems={tempList}
                        setListItems={setTempList}
                        reset={!open}
                        resetFn={resetItems}
                        enableUpdate={enableUpdate}
                        updateFn={handleUpdate}
                        enableSelectAll={false}
                        enableReset={true}
                        groupSelected={true}
                        autoUpdate={true}
                        isLoading={isLoading}
                    />
                </>
            )}
        </FilterToggle>
    );
};

export default Companies;
